import React from 'react';
import PropTypes from 'prop-types';

export function FacilityUnitMicroData({
	storageUnits,
	vehicleUnits,
	facilityName,
	facilityUrl,
	facilityImageUrl,
	facilityId,
	canonicalUrl,
}) {
	const createProductSchemas = () => {
		const schemas = [];
		const sanitizeSizeText = (sizeText) => sizeText.replace(/['\s]/g, '');
		storageUnits.forEach((unit) => {
			schemas.push({
				'@context': 'https://schema.org',
				'@type': 'Product',
				'@id': `${canonicalUrl}#unit-${sanitizeSizeText(unit.sizeText)}`,
				name: `${sanitizeSizeText(unit.sizeText)} Storage Unit`,
				"category": "Self Storage Unit",
				brand: {
					'@type': 'Organization',
					name: facilityName,
				},
				"isRelatedTo": {
       				 "@id": `${canonicalUrl}#selfstorage`
      			},
				offers: {
					'@type': 'Offer',
					price: unit.price.value,
					priceCurrency: 'USD',
					availability: 'https://schema.org/InStock',
				},
			});
		});

		vehicleUnits.forEach((unit) => {
			schemas.push({
				'@context': 'https://schema.org',
				'@type': 'Product',
				'@id': `${canonicalUrl}#unit-${sanitizeSizeText(unit.sizeText)}`,
				name: `${sanitizeSizeText(unit.sizeText)} Storage Unit`,
				"category": "Self Storage Unit",
				brand: {
					'@type': 'Organization',
					name: facilityName,
				},
				"isRelatedTo": {
       				 "@id": `${canonicalUrl}#selfstorage`
      			},
				offers: {
					'@type': 'Offer',
					price: unit.price.value,
					priceCurrency: 'USD',
					availability: 'https://schema.org/InStock',
				},
			});
		});
		return schemas;
	};

	const productSchemas = createProductSchemas();

	return (
		<>
			{productSchemas.map((schema, index) => (
				<script
					key={`Product-${index}`}
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: JSON.stringify(schema)
					}}
				/>
			))}
		</>
	);
}

FacilityUnitMicroData.propTypes = {
	storageUnits: PropTypes.arrayOf(
		PropTypes.shape({
			sizeText: PropTypes.string.isRequired,
			price: PropTypes.shape({
				value: PropTypes.number.isRequired,
			}).isRequired,
		})
	).isRequired,
	vehicleUnits: PropTypes.arrayOf(
		PropTypes.shape({
			sizeText: PropTypes.string.isRequired,
			price: PropTypes.shape({
				value: PropTypes.number.isRequired,
			}).isRequired,
		})
	).isRequired,
	facilityName: PropTypes.string.isRequired,
	facilityUrl: PropTypes.string.isRequired,
	facilityImageUrl: PropTypes.string.isRequired,
	facilityId: PropTypes.string.isRequired,
	canonicalUrl: PropTypes.string.isRequired,
};
